export const RATING_FIELD = "value";
export const USERNAME_FIELD = "userName";
export const EMAIL_FIELD = "userEmail";
export const COMMENT_FIELD = "comment";
